/** The two sides of a comparison. The values are the key prefixes the payload uses. */
export enum ComparisonSide {
  BAROZ = 'baroz',
  COMPETITOR = 'competitor',
}
